import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from '@/routes/AppRoutes';
import { AuthWatcher } from '@/routes/AuthWatcher';
import './index.css';
import { AppProviders } from './providers';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <AppProviders>
        <AuthWatcher>
          <AppRoutes />
        </AuthWatcher>
      </AppProviders>
    </BrowserRouter>
  </React.StrictMode>
);
